import { getDailyRecommendation } from "../../../api/api";
import MatchProfilePage from "./MatchProfilePage";

const DailyRecommendationPage = () => (
  <MatchProfilePage
    title="Daily Recommendations"
    fetchProfiles={getDailyRecommendation}
  />
);

export default DailyRecommendationPage;
